import { storageDateFormat, displayDateFormat } from '@/core';
import moment from 'moment';

let setValue = (state, { key, value }) => state[key] = value;

let setDeviations = (state, deviations) => {
	state.deviations = deviations;
};

let updateSearchFilterDate = (state, { key, isFrom, date }) => {
	let dateMoment = moment(date, displayDateFormat).startOf('day');
	if (isFrom) {
		state.searchFilter[key].from = dateMoment.isValid() ? dateMoment.startOf('day').format(storageDateFormat) : '';
	} else {
		state.searchFilter[key].to = dateMoment.isValid() ? dateMoment.endOf('day').format(storageDateFormat) : '';
	}
};

export default {
	setValue,
	setDeviations,
	updateSearchFilterDate,
};
